import React from 'react';
import * as Sentry from '@sentry/react';
import {Button, Result} from 'antd';

export default function TestBugsink() {
    const [sent, setSent] = React.useState(false);

    const sendTestError = () => {
        try {
            throw new Error("Test error from /test-bugsink page - Bugsink frontend integration check");
        } catch (e) {
            Sentry.captureException(e);
        }
        Sentry.captureMessage("Test message from /test-bugsink page - Bugsink frontend integration check");
        setSent(true);
    };

    return (
        <Result
            status={sent ? "success" : "info"}
            title="Bugsink Integration Test"
            subTitle={sent
                ? "Test error and message sent to Bugsink. Check your Bugsink dashboard."
                : "Click the button below to send a test error and message to Bugsink."
            }
            extra={
                <Button type="primary" onClick={sendTestError}>
                    Send Test Error to Bugsink
                </Button>
            }
        />
    );
}
